import './sectionSingleGame.scss';

import { TimelineLite } from 'gsap';
import ScrollMagic from 'scrollmagic';

export default (() => {
	$(document).ready(function () {
		/**
     * SectionSingleGame animation
     */
		if ($('.section--single-game').length > 0) {
			const controller = new ScrollMagic.Controller();

			// left column animation
			const text = document.querySelector('.single-game__text');
			new ScrollMagic.Scene({
				triggerElement: text,
				triggerHook: '1'
			})
				.on('enter', e => {
					if ($(window).width() > 768) {
						new TimelineLite()
							.fromTo(
								text,
								1,
								{
									opacity: 0
								},
								{
									opacity: 1
								}
							)
							.fromTo(
								text,
								1,
								{
									x: -50,
									y: '50%'
								},
								{
									x: 0,
									y: '0%',
									onComplete: () => {
										text.querySelector('.title').classList.add('title--completed');
									}
								},
								'-=0,8'
							);
					} else {
						text.querySelector('.title').classList.add('title--completed');
					}
				})
				.on('leave', e => {
					text.querySelector('.title').classList.remove('title--completed');
				})
				.addTo(controller);

			// right column animation
			const image = document.querySelector('.single-game__image');
			new ScrollMagic.Scene({
				triggerElement: image,
				triggerHook: '1'
			})
				.on('enter', e => {
					if ($(window).width() > 768) {
						new TimelineLite()
							.fromTo(
								image,
								1,
								{
									opacity: 0
								},
								{
									opacity: 1
								}
							)
							.fromTo(
								image,
								1,
								{
									x: 50,
									y: '50%'
								},
								{
									x: 0,
									y: '0%'
								},
								'-=0,8'
							);
					}
				})
				.addTo(controller);

			// markets animation
			const markets = document.querySelectorAll('.single-game__links ul li');

			new ScrollMagic.Scene({
				triggerElement: markets,
				triggerHook: '1'
			})
				.on('enter', e => {
					let index = 0;
					Array.prototype.forEach.call(markets, function (market) {
						$(market).css({
							animation: `fade-down 1s linear ${0.1 + index * 0.2}s forwards`
						});
						index++;
					});
				})
				.on('leave', e => {
					Array.prototype.forEach.call(markets, function (market) {
						$(market).css({
							animation: ''
						});
					});
				})
				.addTo(controller);
		}
	});
})();
